var pixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;
pixelRatio = Number(pixelRatio);
if (pixelRatio > 1) {
  pixelRatio = 2;
}
export default pixelRatio;